<template>
  <div>
    <Dialog ref="Dialog_tables" :dialogTitle="$t('home.tableSelect')" contentWidth="1000" :closeable="true">

      <div class="mydialog-tables h100p" slot="content">
        <div v-for="(x1,i1) in tables" :key="i1" class="df-fs w100p" :style="'margin-bottom:'+(100/tablesCols*(100-72)/100)+'%;'">
          <div v-for="(x2,i2) in x1" :key="i2" class="item-box df-ct" :style="'width:'+(100/tablesCols)+'%;padding-bottom:'+(100/tablesCols*90/170*(72/100))+'%;'">
            <div class="table-item h100p df-l-c-ct" :class="'value'+x2.status" :style="'font-size:'+textFontSize+'px;line-height:'+textHeight+'px;width:'+72+'%;'" @click="x2.status!==1&&tapTargetTable(x2)">
              <div class="text">{{x2.code}}</div>
              <template v-if="shopConfig_m.tableInfoDisplayType===1">
                <div class="text f-xxxs" style="line-height:12px;" v-if="x2.leftPersons||x2.leftPersons===0&&tablesCols<11">{{x2.leftPersons|tothousands}}{{' '+$t('home.seat')}}</div>
              </template>
              <template v-else>
                <div class="text f-xxxs" style="line-height:12px;">{{x2['showTimeText'+_lang]}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>

    </Dialog>

    <Dialog class="dialog-right" ref="Dialog_table" :dialogTitle="$t('home.orderSelect')" contentWidth="360" :closeable="true">

      <div class="mydialog-table df-l-c-fs h100p" slot="content">
        <div class="dialog-ctr scrolly df-l-c-fs w100p f-xs">
          <div class="dialog-infos2 _borderbottom df-l-fs w100p" v-for="(x,i) in hasTableData" :key="i">
            <div class="dialog-info df-c-sb">
              <div class="df-c-fs">
                <div>{{x.code+(x.showNo>1?('-'+x.showNo):'')}}</div>
                <template v-if="shopConfig_m.tableInfoDisplayType===1">
                  <div v-if="x.diners">（{{$t('home.eatCount')+'：'+x.diners+' '+$t('home.eatCountUnit')}}）</div>
                </template>
                <template v-else-if="x['showTimeText'+_lang]">
                  <div>（{{x['showTimeText'+_lang]}}）</div>
                </template>
              </div>
              <div>{{$t('home.tableSatus'+x.status)}}</div>
            </div>
            <div class="dialog-info2 df-c-sb">
              <!-- <div class="dialog-btn-l themebtn" @click="selectOrder(x)" v-if="x.orderStatus===1">{{$t('common.comfirm')}}</div> -->
              <div class="dialog-btn-l themebtn" @click="selectOrder(x)" v-if="x.dishCanMoveIn">{{$t('common.comfirm')}}</div>
              <div class="dialog-btn-l whitebtn" v-else>{{$t('common.comfirm')}}</div>
            </div>
          </div>
        </div>
      </div>

    </Dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogMove',
  data() {
    return {
      tables: [], // 所有桌子
      orderData: {}, // 当前订单
      foodData: {}, // 当前菜品
      hasTableData: [], // 目标桌子-已开台的订单
    }
  },
  computed: {
    tablesCols() {
      let length = 0
      this.tables.forEach(x => {
        x.length > length ? length = x.length : ''
      })
      return length
    },
    textHeight() {
      let height = (20 - this.tablesCols) * 2
      if (height >= 12) {
        return height
      } else {
        return 12
      }
    },
    textFontSize() {
      if (this.tablesCols < 5) { return 20 }
      else if (this.tablesCols < 15) { return 26 - this.tablesCols }
      else { return 12 }
    },
  },
  methods: {
    // 打开
    async open(order, food) {
      console.log(`%corder, food:`, 'color: #f0f;', order, food)
      this.orderData = order
      this.foodData = food
      await this.getTableData()
      this.$refs.Dialog_tables.open()
    },
    // 点击目标餐桌
    async tapTargetTable(item) {
      console.log(`%c点击的餐桌+id+状态:`, 'color: #f00;', item, item.id, item.status)
      if (item.status !== 1) {
        const _R = await this.getData('table', {
          shopId: this.currentShopId,
          column: item.column,
          row: item.row,
          template: false,
          sceneId: this.sceneId_x,
          queryCanCheckout: true,
          queryOrderStatus: true,
        })
        const ITEM = _R.find(x => x.uniqueCode === this.orderData.uniqueCode && x.column === this.orderData.tableColumn && x.row === this.orderData.tableRow)
        ITEM && (ITEM.dishCanMoveIn = false)
        console.log(`%c9999:`, 'color: #00f;', ITEM)
          
        this.hasTableData = _R.filter(x => x.status > 1)
        this.shopConfig_m.tableInfoDisplayType !== 1 && this.timeHandler(this.hasTableData)
        console.log(`%c已开台:`, 'color: #f00;', _R)
        this.$refs.Dialog_table.open()
      }
    },
    selectOrder(item) {
      // this.$refs.Dialog_table.close()
      // this.$refs.Dialog_tables.close()
      // this.$emit('submitDialog')
      // return
      const rD = {
        fromOrderId: this.orderData.id,
        orderItemId: this.foodData.id,
        toFoodTableId: item.id,
      }
      // console.log(`%crD:`, 'color: #f0f;', rD)
      this.$api.dish_move(rD).then(res => {
        if (res.status == 0) {
          this.$refs.Dialog_table.close()
          this.$refs.Dialog_tables.close()
          this.$emit('submitDialog')
        } else { this._status(res) }
      })
    },
    
    // 初始化餐桌
    initTable(row, column) {
      let arr1 = [], arr2 = []
      for (let i1 = 0; i1 < row; i1++) {
        arr2 = []
        for (let i2 = 0; i2 < column; i2++) {
          arr2.push({ code: '', name: '', status: 0 })
        }
        arr1.push(arr2)
      }
      return arr1
    },
    // #region 处理发送厨房的时间标志
    timeHandler(data) {
      // console.log(`%c22222`, 'color: #f00;',)
      data.forEach(x1 => {
        // x1.showTime = 1665644300654
        if (this.shopConfig_m.tableInfoDisplayType === 2) {
          x1.showTime = x1.tableSendKitchenTime
        } else if (this.shopConfig_m.tableInfoDisplayType === 3) {
          x1.showTime = x1.tableOpenTime
        }
        let CURRENT_TIME = new Date().getTime()
        if (x1.payedTime && x1.payedTime < CURRENT_TIME) [
          CURRENT_TIME = x1.payedTime
        ]
        if (x1.id && x1.showTime) {
          let t = Math.floor((CURRENT_TIME - x1.showTime) / 1000 / 60)
          if (t > 999) t = '>999'
          if (t < 0) t = '0'
          this.$set(x1, 'showTimeText_zh', t + '分鐘')
          this.$set(x1, 'showTimeText_en', t + ' Min')
        } else {
          this.$set(x1, 'showTimeText_zh', '')
          this.$set(x1, 'showTimeText_en', '')
        }
      })
    },
    // #endregion
    // 获取 餐桌
    async getTableData() {
      const _R = await this.getData('table', {
        shopId: this.currentShopId,
        template: true,
        sceneId: this.sceneId_x,
        pageSize: 300,
      })
      if (_R.length) {
        let row = 0, column = 0
        _R.forEach(x => {
          x.row > row && (row = x.row)
          x.column > column && (column = x.column)
        })
        if (column < row) {
          column = row
        }
        const tables = this.initTable(row, column)
        _R.forEach(x => {
          x.leftPersons_ori = x.leftPersons
          tables[x.row - 1][x.column - 1] = x
        })
        // console.log(`%cthis.shopConfig_m.tableInfoDisplayType:`, 'color: #f0f;', this.shopConfig_m.tableInfoDisplayType)
        this.shopConfig_m.tableInfoDisplayType !== 1 && tables.forEach(x1 => {
          this.timeHandler(x1)
        })
        this.tables = tables
        // console.log(`%c处理的餐桌:`, 'color: #00f;', this.tables)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mydialog-tables{
  overflow: hidden scroll;height: 500px;margin-top: 20px;
  .item-box{height: 0;box-sizing: border-box;position: relative;}
  
  // 餐桌樣式
  .table-item{
    border-radius: 4%;box-sizing: border-box;position: absolute;
    // &.value0{background: #E7E7E7;border: 1px solid #538692;}
    &.value1{background: #eee !important;border: 1px solid #538692 !important;}
    &.value2{background: #1972FB !important;border: none !important;}
    &.value3{background: #FB8319 !important;border: none !important;}
    &.value4{background: #1972FB !important;border: none !important;overflow: hidden;}
    &.value4::after {
      content: '';display: inline-block;width: 100%;height: 100%;background: #FE4545;
      transform: rotate(-45deg);position: absolute;top: 75%;left: 50%;
    }
    .text{color: #fff;text-align: center;z-index: 10;position: relative;}
    &.value1 .text{color: #555;}
  }
}

.dialog-right{
  /deep/.el-dialog{height: 580px;position: absolute;bottom: 28px;right: 20px;margin: 0!important;}
}
.mydialog-table{
  height: 520px;box-sizing: border-box;
  .dialog-ctr{flex: 1;box-sizing: border-box;padding: 0 20px 120px;}
  .dialog-infos2{height: 129px;padding: 10px 0;box-sizing: border-box;}
  .dialog-info{height: 44px;}
  .dialog-info2{height: 64px;}
  .dialog-info:last-child{flex: 1;}

  .dialog-btn-l{width: 100%;}
}
</style>